<div class="content">
  <div class="inputRow">
    <mat-form-field class="inputField" [subscriptSizing]="'dynamic'">
      <mat-label>Project Name</mat-label>
      <input #projectNameInput maxlength="30" matInput [(ngModel)]="projectName"/>
      <mat-hint align="end">{{ projectNameInput.value.length }} / 30</mat-hint>
    </mat-form-field>
  </div>
  <div class="inputRow">
    <mat-form-field class="locationField" [subscriptSizing]="'dynamic'">
      <mat-label>Location City</mat-label>
      <input #locationCityInput maxlength="50" matInput [(ngModel)]="locationCity"/>
      <mat-hint align="end">{{ locationCityInput.value.length }} / 50</mat-hint>
    </mat-form-field>
    <mat-form-field class="locationField" [subscriptSizing]="'dynamic'">
      <mat-label>Location State</mat-label>
      <input #locationStateInput maxlength="4" matInput [(ngModel)]="locationState"/>
      <mat-hint align="end">{{ locationStateInput.value.length }} / 4</mat-hint>
    </mat-form-field>
    <mat-form-field class="locationField" [subscriptSizing]="'dynamic'">
      <mat-label>Location Zip</mat-label>
      <input #locationPostalCodeInput maxlength="20" matInput [(ngModel)]="locationZip"/>
      <mat-hint align="end">{{ locationPostalCodeInput.value.length }} / 20</mat-hint>
    </mat-form-field>
  </div>
  <div class="inputRow">
    <mat-form-field class="inputField" [subscriptSizing]="'dynamic'">
      <mat-label>Notes</mat-label>
      <input matInput [(ngModel)]="notes"/>
    </mat-form-field>
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button matButton="elevated" class="dialogButton warn-button" (click)="cancel()">Cancel</button>
    <button matButton="elevated" [disabled]="!isValid()" class="dialogButton primary-button" (click)="create()">Create
      Schedule
    </button>
  </div>
</div>
